import React from "react"

const CallToActionBanner = ({
  title,
  description,
  footerText,
  background,
  action,
  secondaryAction,
  children,
}) => {
  const PrimaryActionComponent = action

  return (
    <div
      className={`call-to-action-banner ${
        background ? `call-to-action-banner--${background}` : ""
      }`}
    >
      <div className="call-to-action-banner__inner">
        {title && <h2 className="call-to-action-banner__title">{title}</h2>}

        {description && (
          <p className="p--lg call-to-action-banner__description">
            {description}
          </p>
        )}

        {children && children}

        <div className="call-to-action-banner__actions">
          <PrimaryActionComponent
            className={`btn btn--lg ${
              background === "blue" || background === "black"
                ? "btn--secondary"
                : "btn--primary"
            } call-to-action-banner__button`}
          />

          {secondaryAction}
        </div>

        {footerText && (
          <p className="p--sm call-to-action-banner__footer">{footerText}</p>
        )}
      </div>
    </div>
  )
}

export default CallToActionBanner
